import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as dateutil from '@appbase/util/date-helper';

@Component({

})
export default class WeekAlldayItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.DateItem;

    allDayEventsModel: reserve.CalendarItem[] = [];

    @Watch('item')
    itemChaged(newVal: reserve.DateItem) {
        this.allDayEventsModel = this.item.events.filter(e => e.isAllDayEvent && e.id !== 'null' && (dateutil.uGetDateFormat_UTC("dd", new Date(e.start)) === this.item.date.getDate().toString()));        
    }

    created() {
        if(this.item != null) {
            this.itemChaged(this.item);
        }
    }

    getColorClass(event: reserve.CalendarItem) {
        var colorClass: any = {};
        colorClass[event.color] = true;
        return colorClass;
    }
}